export default __webpack_public_path__ + "static/media/menu-icon-circles.2aed467a.svg";